import React, { useContext, useEffect, useMemo, useState } from "react";

//import { clients, folders, sessions, tasks, leftMenu, bottomMenu } from '../../mocks/dashboard';
import { leftMenu, bottomMenu, tasks, sessions } from '../../mocks/dashboard';
import { formatDate1, formatDate2 } from '../../utils/dateFormats';
import { SideMenu } from "./components/sideMenu/SideMenu";
import { Spinner } from "../../components/spinner/Spinner";
import { DashboardLeftBottom } from "./DashboardLeftBottom";
import { DashboardClientPopupRouter } from "./DashboardClientPopupRouter";
import { DashboardRightRouter } from "./DashboardRightRouter";
import { ScheduleTab } from "./components/scheduleTab/ScheduleTab";

import "./DashboardRight.css";
import "./DashboardList.css";
import "./DashboardPage.css";
import { AppContext } from "../../appContext";
import { IClientData, ISession, ITask } from "../../types/dashboard";
import { SlidableMenu } from "../../components/slidableMenu/SlidableMenu";
import { useNavigate, useParams } from "react-router-dom";
import { getAvatarById } from "../../utils/avatars";
import { DashboardController } from "./DashboardController";
import { DashboardContext } from "./DashboardContext";
import { DashboardMain } from "./DashboardMain";
import { DashboardClients } from "./DashboardClients";
import { DashboardSearches } from "./DashboardSearches";
import { CalendarGrid } from "../../components/calendarGrid/CalendarGrid";
import { SideMenuRouter } from "./components/sideMenu/SideMenuRouter";
import { clearNavigationState } from "../../utils/navigationStatePersistence";
//import { AddClientContexted}  from "./components/addClient/AddClientContexted";
console.log(getAvatarById('01'));

const DASHBOARD_SIDE_TITLES: Record<string, string> = {
    settings:      'Kitsugi · Settings',
    profile:       'Kitsugi · Profile',
    faq:           'Kitsugi · FAQ',
    privacy:       'Kitsugi · Privacy',
    language:      'Kitsugi · Language',
    quickstart:    'Kitsugi · Quickstart',
    help:          'Kitsugi · Help',
    administrator: 'Kitsugi · Admin',
};

const DASHBOARD_POPUP_TITLES: Record<string, string> = {
    FullSessionList: 'Kitsugi · Sessions',
    Notes:           'Kitsugi · Notes',
    Calendar:        'Kitsugi · Calendar',
    TotalCalendar:   'Kitsugi · Calendar',
    Lifeline:        'Kitsugi · Lifeline',
    Mindmap:         'Kitsugi · Board',
    FullAnalysis:    'Kitsugi · Analysis',
    Statistic:       'Kitsugi · Statistics',
    Tasks:           'Kitsugi · Tasks',
    TreatmentPlan:   'Kitsugi · Treatment Plan',
    Chat:            'Kitsugi · Chat',
};

export const DashboardPage = () => {
    const dashboardContext = useContext(DashboardContext);
    const {
        selectedClientId, setSelectedClientId,
        selectedTaskIndex, setSelectedTaskIndex,
        selectedSessionIndex, setSelectedSessionIndex,
        selectedFolderIndex, setSelectedFolderIndex,
        selectedBottomMenuTabId, setSelectedBottomMenuTabId,
        selectedLeftMenuTabIndex, setSelectedLeftMenuTabIndex,
        activeTag, setActiveTag,
        isDashWrap, setDashWrap,
        isLeftCollapsed, setLeftCollapsed,
        showMenu, setShowMenu,
        selectedClient,
        activePopup, setActivePopup,
        setTaskList,
        addClient,
        editClient,
        deleteClient: _deleteClient,
        editSession,
        deleteSession: _deleteSession,
        sideSelected,
        setSideSelected,
        bottomSelected,
        setBottomSelected,
        isDashboardVisible,
        setIsDashboardVisible
    } = dashboardContext;

    //const [bottomSelected, setBottomSelected] = useState<string>();

    const contextData = useContext(AppContext);
    const appContext = useContext(AppContext);
    const { translate, currentLanguage } = appContext;
    
    const isClientsLoaded = !!contextData.clients;
    const clientsData = contextData.clients || [];
    //const setClientsData = contextData.setClients;

    const clients = useMemo(()=>clientsData.map(it=>{
        return {
            id: it.id,
            name: it.name,
            date1: it.sessions?.[0] ? formatDate1(new Date(it.sessions[0]?.date), translate, currentLanguage) : '',
            date2: it.sessions?.[1] ? formatDate1(new Date(it.sessions[1]?.date), translate, currentLanguage) : '',
            avatarUrl: it.avatarUrl,
            waitLoading: it.waitLoading
        }
    }), [clientsData, translate, currentLanguage]);

    /*const setSessionData = (setter: (last: ISession[])=>ISession[])=>{
        setClientsData(lastClients=>{
            const selected = lastClients[selectedClientIndex];
            selected.sessions = setter(selected.sessions) as any;
            return [...lastClients]
        });
    }*/
    const params = useParams();
    const navigate = useNavigate();
    console.log(dashboardContext)

    useEffect(()=>{
        console.log('DashboardPage activeTag changed:', activeTag);
        if (activeTag == 'Treatment plan'){
            setActivePopup('TreatmentPlan');
        }
        if (activeTag == 'Lifeline'){
            setActivePopup('Lifeline');
        }
        if (activeTag == 'Statistic'){
            setBottomSelected('statistic');
            setActivePopup('');
        }
        if (activeTag == 'Analysis'){
            setActivePopup('FullAnalysis');
        }
        if (activeTag == 'Notes'){
            console.log('Setting activePopup to Notes');
            setActivePopup('Notes');
            setBottomSelected('');
        }
    }, [activeTag]);

    useEffect(()=>{
        const bottomMenuItem = selectedBottomMenuTabId;
        console.log('DashboardPage selectedBottomMenuTabId changed:', bottomMenuItem);
        if (bottomMenuItem == 'Sessions'){
            setActivePopup('FullSessionList');
            setDashWrap(false);
            setIsDashboardVisible(false);
        }
        if (bottomMenuItem == 'Notes'){
            console.log('Bottom menu Notes clicked - setting activePopup to Notes');
            setActivePopup('Notes');
            setBottomSelected('');
            setDashWrap(false);
            setIsDashboardVisible(false);
        }
        if (bottomMenuItem == 'Mindmap'){
            setActivePopup('Mindmap');
            setDashWrap(false);
            setIsDashboardVisible(false);
        }
        if (bottomMenuItem == 'Lifeline'){
            setActivePopup('Lifeline');
            setDashWrap(false);
            setIsDashboardVisible(false);
        }
        if (bottomMenuItem == 'Calendar'){
            setActivePopup('Calendar');
            setDashWrap(false);
            setIsDashboardVisible(false);
        }
        if (bottomMenuItem == 'Treatment plan'){
            setActivePopup('TreatmentPlan');
            setDashWrap(false);
            setIsDashboardVisible(false);
        }
        if (bottomMenuItem == 'Chat'){
            setActivePopup('Chat');
            setDashWrap(false);
            setIsDashboardVisible(false);
        }
        if (bottomMenuItem == 'Analysis'){
            setActivePopup('FullAnalysis');
            setDashWrap(false);
            setIsDashboardVisible(false);
        }
        if (bottomMenuItem == 'Statistic'){
            setActivePopup('Statistic');
            setDashWrap(false);
            setIsDashboardVisible(false);
        }
        if (bottomMenuItem == 'Tasks'){
            setActivePopup('Tasks');
            setDashWrap(false);
            setIsDashboardVisible(false);
        }
    }, [selectedBottomMenuTabId]);

    useEffect(()=>{
        if (activePopup == ''){
            setActiveTag('');
        }
    }, [activePopup])

    useEffect(() => {
        if (sideSelected && DASHBOARD_SIDE_TITLES[sideSelected]) {
            document.title = DASHBOARD_SIDE_TITLES[sideSelected];
        } else {
            document.title = DASHBOARD_POPUP_TITLES[activePopup] ?? 'Kitsugi · Dashboard';
        }
    }, [activePopup, sideSelected]);

    /*const loadClients = ()=>{
        _loadClients().then(result => {
            setClientsData(result);
        })
    } */

    /*useEffect(()=>{
        if (!appContext.user){
            return;
        }
        loadClients();
    }, [appContext.user]);*/

    useEffect(()=>{
        const client = clients?.find(it=> it.id == params.id)
        if (client != undefined && selectedClientId == null){
            setSelectedClientId(client.id);
            setSelectedBottomMenuTabId('Sessions');
            setActivePopup('FullSessionList');
            navigate('/dashboard'); //hide initial client id from url
        }
    }, [clients]);

    // Clear navigation state when user explicitly clicks "Start screen"
    useEffect(() => {
        if (selectedClientId === null && activePopup === '' && sideSelected === '') {
            clearNavigationState();
        }
    }, [selectedClientId, activePopup, sideSelected]);

    const startScreenClick = () => {
        setSelectedClientId(null);
        setActivePopup('');
        setSideSelected('');
        setBottomSelected('learning');
        // Clear saved navigation state when explicitly going to start screen
        clearNavigationState();
    }

    const toggleLeftCollapsed = (value: boolean) => {
        setLeftCollapsed(value);
    }

    const slidableMenu = true;

    useEffect(()=>{
        if (bottomSelected == 'upcoming'){
            setActivePopup('Calendar');
            setSelectedBottomMenuTabId('Calendar');
            setSelectedLeftMenuTabIndex(1); // Switch to Schedule tab (index 1)
        }
        if (bottomSelected == 'learning'){
            setSelectedLeftMenuTabIndex(0); // Switch to All Clients tab (index 0)
        }
    }, [bottomSelected]);

    const handleBottomMenuSelect = (name: string) => {
        if (name === 'learning') {
            // If a client is already selected, show their session list
            if (selectedClientId) {
                setActivePopup('FullSessionList');
                setSelectedBottomMenuTabId('Sessions');
            } else {
                setActivePopup(''); // Close any active popup when no client is selected
            }
        }
        setBottomSelected(name);
    };

    useEffect(()=>{
        if (bottomSelected == 'upcoming' && (activePopup && activePopup !='TotalCalendar' && activePopup !='Calendar')){
            setBottomSelected('learning');
            setSelectedLeftMenuTabIndex(0); // Switch back to All Clients tab (index 0)
        }
        // Switch to Schedule tab when calendar is opened
        if ((activePopup == 'TotalCalendar' || activePopup == 'Calendar') && bottomSelected != 'upcoming') {
            setSelectedLeftMenuTabIndex(1); // Switch to Schedule tab (index 1)
        }
    }, [activePopup]);

    // Sync bottomSelected with activePopup for correct button highlighting
    // Only sync when calendar popups are opened - don't reset to learning on empty activePopup
    useEffect(() => {
        if (activePopup === 'TotalCalendar' || activePopup === 'Calendar') {
            if (bottomSelected !== 'upcoming') {
                setBottomSelected('upcoming');
            }
        }
    }, [activePopup]);

    return (
    <div className="dashboard">
        <div className={`dashboard_left_collapser ${isLeftCollapsed ? 'dashboard_left_collapser--collapsed' : ''}`}>
            <div className="dashboard_left_collapser_holder">
                <div className="button dashboard_left_collapser_button" onClick={()=>toggleLeftCollapsed(false)}></div>
            </div>
        <div className="dashboard_left">
            <div className="dashboard_left_header">
                <div className="button dashboard_left_logo" onClick={startScreenClick/*()=>setShowMenu(last=>!last)*/}>

                </div>
                <div className="dashboard_left_path">
                    <div className="dashboard_left_device">
                        {translate('sideMenu_desktop')}
                    </div>
                    <div className="button dashboard_left_screen" onClick={startScreenClick}>
                        {translate('sideMenu_startScreen')}
                    </div>
                </div>
                <div className="dashboard_left_hide_wrap">
                    <div className="button dashboard_left_hide" onClick={()=>toggleLeftCollapsed(true)}>
                        <div className="dashboard_left_hide_icon"></div>

                    </div>
                </div>
            </div>

            {/*showMenu*/ (bottomSelected == 'avatar') ? <SideMenu selected={""} onSelect={(name)=>{setSideSelected(name)}}></SideMenu>:
            <>
                <DashboardSearches></DashboardSearches>
                <DashboardClients></DashboardClients>

            </>}
            <DashboardLeftBottom selectedButton={bottomSelected} onSelect={handleBottomMenuSelect}></DashboardLeftBottom>

        </div>
        </div>
        <div className="dashboard_right">
            <DashboardRightRouter></DashboardRightRouter>
        </div>
        {/*<div className="dashboard_right">
            {(selectedClientIndex == -1 || !clientsData[selectedClientIndex]) ? ( activePopup!='AddClient' && <Desktop></Desktop>):
            <>
            <DashboardHead 
                activeTag={activeTag} 
                setActiveTag={setActiveTag} 
                onWrapClick={()=>{setDashWrap(last=>!last)}} 
                isWrap={isDashWrap} 
                client={clients[selectedClientIndex]}
            ></DashboardHead>
            <div className={`dashboard_main_drop ${!isDashWrap ? '' : 'dashboard_main_drop--opened'}`}>
                <DashboardMain></DashboardMain>
            </div>

                {!slidableMenu ? <BottomMenu
                    bottomMenu={bottomMenu} 
                    selectedBottomMenuTabIndex={selectedBottomMenuTabIndex}
                    setSelectedBottomMenuTabIndex={setSelectedBottomMenuTabIndex}
                ></BottomMenu> :
                <SlidableMenu
                    items={bottomMenu}
                    selectedItemIndex={selectedBottomMenuTabIndex}
                    onSelect={(num)=>setSelectedBottomMenuTabIndex(num)}
                ></SlidableMenu>
                }
                <DashboardClientPopupRouter></DashboardClientPopupRouter>

            </>}
            {
                activePopup == 'AddClient' && <AddClient 
                    onClose={()=>setActivePopup('')} 
                    onSave={(data)=>{
                        setActivePopup('');
                        addClient(data)
                    }} 
                    onSaveDraft={()=>{}}
                ></AddClient>
            }
            {sideSelected && <SideMenuRouter selected={sideSelected} onSelect={(name)=>setSideSelected(name)}>

            </SideMenuRouter>}
        </div>*/}
    </div>
    )
}